import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { ImportSupplier, ImportSupplierRequest } from '../models/import-supplier';

export class ImportSuppliersApi {
    constructor(protected baseUrl: string) {}

    public getImportSuppliers(params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<ImportSupplier>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/import-suppliers`, { params }),
            response => {
                response.data.items = response.data.items.map(ImportSupplier.fromPlainObject);
                return response.data;
            }
        );
    }

    public deleteImportSupplier(importSupplierId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/import-suppliers/${importSupplierId}/delete`),
            () => null
        );
    }

    public addImportSupplier(importSupplier: ImportSupplierRequest): Promise<ApiResult<ImportSupplier>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/import-suppliers`, importSupplier),
            response => {
                return response.data;
            }
        );
    }

    public updateImportSupplier(
        importSupplierId: number,
        importSupplier: ImportSupplierRequest
    ): Promise<ApiResult<ImportSupplier>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/import-suppliers/${importSupplierId}`, importSupplier),
            response => {
                return response.data;
            }
        );
    }
}
